module.exports = __webpack_public_path__ + "img/Teamwork.b094da7f.png";